<script setup lang="ts">
import InstructionBlock from '@/components/app/shared/flight-sharing/InstructionBlock'

export default {
  components: { InstructionBlock },
}
</script>

<template>
	<div class="flex flex-col gap-16 lg:gap-40">
		<div class="group">
			<div class="instruction-block relative flex flex-col justify-center items-center">
				<div
					class="hidden lg:block absolute mr-20 w-48 h-48 bg-cream-200 rounded-full flex-shrink-0"
					style="right: 100%;"
				>
					<img
						src="/assets/img/app/flight-sharing/open-flight/app.webp"
						alt="Smartphone showing the Jetfly owner mobile app"
						class="max-w-none absolute transform group-hover:translate-y-1 group-hover:-translate-x-1 transition-transform ease-out duration-500"
						style="height: 295px; top: -62px; left: -59px;"
					/>
					<img
						src="/assets/img/app/flight-sharing/open-flight/info.webp"
						alt="Section of mobile app showing shared seat allocation"
						class="max-w-none absolute transform group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:scale-105 transition-transform ease-out duration-500"
						style="width: 200px; top: 28px; left: 18px;"
					/>
				</div>
				<InstructionBlock
					letter="A"
					title="How to open your flight"
					:items="[
						`Open the Jetfly App.`,
						`Go to Book > Book a Flight.`,
						`Submit your flight request. A pop-up will ask if you'd like to open it to other Owners.`,
						`Select the number of seats to open. You'll see an estimated revenue.`,
						`Tap Open My Flight.`,
					]"
				/>
			</div>
		</div>
		<div class="group">
			<div class="instruction-block relative flex flex-col items-center">
				<div
					class="hidden lg:block absolute mr-20 w-48 h-48 bg-cream-200 rounded-full flex-shrink-0"
					style="right: 100%; top: -54px;"
				>
					<img
						src="/assets/img/app/flight-sharing/book-seat/app.webp"
						alt="Smartphone showing the Jetfly owner mobile app"
						class="max-w-none absolute transform group-hover:translate-y-1 group-hover:-translate-x-1 transition-transform ease-out duration-500"
						style="height: 296px; top: 54px; left: -59px;"
					/>
					<img
						src="/assets/img/app/flight-sharing/book-seat/info.webp"
						alt="Section of mobile app showing seat booking"
						class="max-w-none absolute transform group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:scale-105 transition-transform ease-out duration-500"
						style="width: 200px; top: 22px; left: 6px;"
					/>
				</div>
				<InstructionBlock
					letter="B"
					title="How to book a seat on a flight"
					:items="[
						`Open the Jetfly App.`,
						`Go to Book > Opportunities and select an opened flight.`,
						`A pop-up will ask you to select the number of seats and a contract. You can also add special request and have a look at the Flight Sharing conditions.`,
						`Tap “Book seat”.`,
						`Your request has been sent. Once validated, you will receive confirmation.`,
					]"
				/>
			</div>
		</div>
		<div class="group">
			<div class="instruction-block relative flex flex-col items-center">
				<div
					class="hidden lg:block absolute -mt-4 w-48 h-48 bg-cream-200 rounded-full flex-shrink-0"
					style="right: 100%; margin-right: 140px;"
				>
					<img
						src="/assets/img/app/flight-sharing/track-bookings/in-progress.webp"
						alt="Section of mobile app showing a booking in progress"
						class="max-w-none absolute transform group-hover:translate-y-1 group-hover:-translate-x-1 transition-transform ease-out duration-500"
						style="width: 237px; top: 30px; left: -14px;"
					/>
					<img
						src="/assets/img/app/flight-sharing/track-bookings/confirmed.webp"
						alt="Section of mobile app showing a booking confirmed"
						class="max-w-none absolute transform group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:scale-105 transition-transform ease-out duration-500"
						style="width: 239px; top: 59px; left: -35px;"
					/>
				</div>
				<InstructionBlock
					letter="C"
					title="How to track bookings"
					:items="[
						`Go to My Flights, select the flight.`,
						`View your flight summary, the number of booked seats and savings on if you opened your flight.`,
					]"
				/>
			</div>
		</div>
	</div>
</template>

<style>
@media (width >= 64rem) {
	.instruction-block {
		margin-left: 368px;
	}
}
</style>
